var santal = (function ($) {
  var _santalJS = function () {
    var VNs = document.getElementsByClassName("ingredients-collapse");
    let SCs = document.getElementsByClassName("sitios-compra");
    let btnVNs = document.getElementsByClassName("ingredients-title");

    // almendra
    var btnAlmendraVN = document.getElementById("btn-VN-almendra");
    var VNAlmendra = document.getElementById("home-product-almendra-detail");
    // avena
    var btnavenaVN = document.getElementById("btn-VN-avena");
    var VNavena = document.getElementById("home-product-avena-detail");

    // soja
    var btnsojaVN = document.getElementById("btn-VN-soja");
    var VNsoja = document.getElementById("home-product-soja-detail");

    // coco
    var btncocoVN = document.getElementById("btn-VN-coco");
    var VNcoco = document.getElementById("home-product-coco-detail");

    //////////////////////////////////////
    //SUPERPOSICION SITIOS COMPRA CON VN//
    //////////////////////////////////////
    // almendra
    for (let i = 0; i < SCs.length; i++) {
      SCs[i].addEventListener(
        "show.bs.collapse",
        function () {
          showSCs(SCs[i]);
        },
        false
      );
      SCs[i].addEventListener(
        "hide.bs.collapse",
        function () {
          hideSCs(SCs[i]);
        },
        false
      );
    }

    for (let i = 0; i < VNs.length; i++) {
      VNs[i].addEventListener(
        "show.bs.collapse",
        function () {
          showVNs(VNs[i]), false;
        },
        false
      );
    }

    function showVNs(VN) {
      ///////////////////////////
      //CERRAR VN AL ABRIR OTRO//
      ///////////////////////////
      console.log(btnVNs[0].getAttribute("aria-expanded"));

      for (let i = 0; i < VNs.length; i++) {
        if (VNs[i].classList.contains("show") && VNs[i] !== VN) {
          cerrarDesplegable(btnVNs[i], VNs[i]);
        }
      }

      //////////////////////////////////////
      //SUPERPOSICION SITIOS COMPRA CON VN//
      //////////////////////////////////////
      if (screen.width > 979) {
        let SC = VN.previousElementSibling;
        console.log(SC);
        if (
          SC.classList.contains("sitios-compra") &&
          SC.classList.contains("show")
        ) {
          console.log("sitooooo");
          //añadir margen
          if (window.innerWidth > 1200) {
            VN.style.marginTop = "-112px";
          } else if (window.innerWidth > 980) {
            VN.style.marginTop = "-110px";
          } else if (window.innerWidth > 768) {
            VN.style.marginTop = "-106px";
          } else {
            VN.style.marginTop = "-75px";
          }
        } else {
          //margen 0
          VN.style.marginTop = "0px";
        }
      }
    }

    function showSCs(SN) {
      console.log("okkk");
      if (screen.width > 979) {
        let VN = SN.nextElementSibling;
        console.log;
        if (
          VN.classList.contains("ingredients-collapse") &&
          VN.classList.contains("show")
        ) {
          //añadir margen
          if (window.innerWidth > 1200) {
            VN.style.marginTop = "-112px";
          } else if (window.innerWidth > 980) {
            VN.style.marginTop = "-110px";
          } else if (window.innerWidth > 768) {
            VN.style.marginTop = "-106px";
          } else {
            VN.style.marginTop = "-75px";
          }
        }
      }
    }

    function hideSCs(SN) {
      if (screen.width > 979) {
        let VN = SN.nextElementSibling;
        if (VN.classList.contains("show")) {
          //añadir margen
          VN.style.marginTop = "0px";
        }
      }
    }

    function cerrarDesplegable(btnVN, VN) {
      btnVN.setAttribute("aria-expanded", "false");
      btnVN.setAttribute("class", "ingredients-title collapsed");
      VN.classList.remove("show");
      VN.setAttribute("style", "height: 0px");
    }

    //////////////////////////////////////////
    //COLAPSABLE VN ABIERTO EN URL CON ANCLA//
    //////////////////////////////////////////
    window.onload = function () {
      // almendra
      if (window.location.hash == "#desplegable-VN-almendra") {
        btnAlmendraVN.setAttribute("aria-expanded", "true");
        btnAlmendraVN.setAttribute("class", "ingredients-title");
        VNAlmendra.setAttribute("aria-expanded", "true");
        let atributoViejo = VNAlmendra.getAttribute("class");
        let atributoIN = " show";
        let atributoNuevo = atributoViejo.concat(atributoIN);
        VNAlmendra.setAttribute("class", atributoNuevo);
        VNAlmendra.setAttribute("style", "height: auto");
        if (screen.width > 979) {
          window.scrollTo(0, 2500);
        }
      }

      // avena
      if (window.location.hash == "#desplegable-VN-avena") {
        btnavenaVN.setAttribute("aria-expanded", "true");
        btnavenaVN.setAttribute("class", "ingredients-title");
        VNavena.setAttribute("aria-expanded", "true");
        let atributoViejo = VNavena.getAttribute("class");
        let atributoIN = " show";
        let atributoNuevo = atributoViejo.concat(atributoIN);
        VNavena.setAttribute("class", atributoNuevo);
        VNavena.setAttribute("style", "height: auto");
        if (screen.width > 979) {
          window.scrollTo(0, 2925);
        }
      }

      // soja
      if (window.location.hash == "#desplegable-VN-soja") {
        btnsojaVN.setAttribute("aria-expanded", "true");
        btnsojaVN.setAttribute("class", "ingredients-title");
        VNsoja.setAttribute("aria-expanded", "true");
        let atributoViejo = VNsoja.getAttribute("class");
        let atributoIN = " show";
        let atributoNuevo = atributoViejo.concat(atributoIN);
        VNsoja.setAttribute("class", atributoNuevo);
        VNsoja.setAttribute("style", "height: auto");
        if (screen.width > 979) {
          window.scrollTo(0, 3400);
        }
      }

      // coco
      if (window.location.hash == "#desplegable-VN-coco") {
        btncocoVN.setAttribute("aria-expanded", "true");
        btncocoVN.setAttribute("class", "ingredients-title");
        VNcoco.setAttribute("aria-expanded", "true");
        let atributoViejo = VNcoco.getAttribute("class");
        let atributoIN = " show";
        let atributoNuevo = atributoViejo.concat(atributoIN);
        VNcoco.setAttribute("class", atributoNuevo);
        VNcoco.setAttribute("style", "height: auto");
        if (screen.width > 979) {
          window.scrollTo(0, 4300);
        }
      }
    };
  };

  var _createCookies = function () {
    var settings = $("#cookie_preferences").cookiePreferences("settings");
    if (settings && settings.functionality) {
      // Evento y variable de Google Tag Manager (Funcionalidad)
      dataLayer.push({
        cookie_functionality: "true",
        event: "consent_functionality",
      });
    }

    if (settings && settings.analysis) {
      // Evento y variable de Google Tag Manager (Rendimiento)
      dataLayer.push({
        cookie_analysis: "true",
        event: "consent_analysis",
      });
    }

    if (settings && settings.advertising) {
      // Evento y variable de Google Tag Manager (Dirigidas)
      dataLayer.push({
        cookie_ads: "true",
        event: "consent_ads",
      });
    }
  };

  var _updateCookieSelection = function () {
    $("#CookiePreferenceDialogBodyLevelButtonFuncionality").on(
      "click",
      function () {
        if (
          $("#CookiePreferenceDialogBodyLevelButtonFuncionality").is(":checked")
        ) {
          $("#CookiePreferenceDialogBodyLevelButtonFuncionalityInline").prop(
            "checked",
            true
          );
        } else {
          $("#CookiePreferenceDialogBodyLevelButtonFuncionalityInline").prop(
            "checked",
            false
          );
        }
      }
    );

    $("#CookiePreferenceDialogBodyLevelButtonFuncionalityInline").on(
      "click",
      function () {
        if (
          $("#CookiePreferenceDialogBodyLevelButtonFuncionalityInline").is(
            ":checked"
          )
        ) {
          $("#CookiePreferenceDialogBodyLevelButtonFuncionality").prop(
            "checked",
            true
          );
        } else {
          $("#CookiePreferenceDialogBodyLevelButtonFuncionality").prop(
            "checked",
            false
          );
        }
      }
    );

    $("#CookiePreferenceDialogBodyLevelButtonPerformance").on(
      "click",
      function () {
        if (
          $("#CookiePreferenceDialogBodyLevelButtonPerformance").is(":checked")
        ) {
          $("#CookiePreferenceDialogBodyLevelButtonPerformanceInline").prop(
            "checked",
            true
          );
        } else {
          $("#CookiePreferenceDialogBodyLevelButtonPerformanceInline").prop(
            "checked",
            false
          );
        }
      }
    );

    $("#CookiePreferenceDialogBodyLevelButtonPerformanceInline").on(
      "click",
      function () {
        if (
          $("#CookiePreferenceDialogBodyLevelButtonPerformanceInline").is(
            ":checked"
          )
        ) {
          $("#CookiePreferenceDialogBodyLevelButtonPerformance").prop(
            "checked",
            true
          );
        } else {
          $("#CookiePreferenceDialogBodyLevelButtonPerformance").prop(
            "checked",
            false
          );
        }
      }
    );

    $("#CookiePreferenceDialogBodyLevelButtonAdvertising").on(
      "click",
      function () {
        if (
          $("#CookiePreferenceDialogBodyLevelButtonAdvertising").is(":checked")
        ) {
          $("#CookiePreferenceDialogBodyLevelButtonAdvertisingInline").prop(
            "checked",
            true
          );
        } else {
          $("#CookiePreferenceDialogBodyLevelButtonAdvertisingInline").prop(
            "checked",
            false
          );
        }
      }
    );

    $("#CookiePreferenceDialogBodyLevelButtonAdvertisingInline").on(
      "click",
      function () {
        if (
          $("#CookiePreferenceDialogBodyLevelButtonAdvertisingInline").is(
            ":checked"
          )
        ) {
          $("#CookiePreferenceDialogBodyLevelButtonAdvertising").prop(
            "checked",
            true
          );
        } else {
          $("#CookiePreferenceDialogBodyLevelButtonAdvertising").prop(
            "checked",
            false
          );
        }
      }
    );
  };

  return {
    santalJS: _santalJS,
    createCookies: _createCookies,
    updateCookieSelection: _updateCookieSelection,
  };
})(jQuery);

export default santal;
